/**
 * Lazy loader for Supabase client
 * Use getSupabaseClient() inside async functions so Supabase is only loaded when needed.
 */
let cachedClient: any = null;

export async function getSupabaseClient() {
  if (cachedClient) return cachedClient;
  // Dynamically import the client re-export to keep the same import path used across the app
  const module = await import('./client');
  cachedClient = module.supabase;
  return cachedClient;
}
